export const SET_STEP = 'MINHASDIVIDAS/SET_STEP';
export const SET_CURRENTCOMPONENT = 'MINHASDIVIDAS/SET_CURRENTCOMPONENT';
export const SET_DIVIDAS = 'MINHASDIVIDAS/SET_DIVIDAS';
export const SET_BOLETO_EXPRESSO= 'MINHASDIVIDAS/SET_BOLETO_EXPRESSO';
export const SET_NEGOCIACAO = 'MINHASDIVIDAS/SET_NEGOCIACAO';
export const SET_ACORDO = 'MINHASDIVIDAS/SET_ACORDO';
export const SET_NEGOTIABLE = 'MINHASDIVIDAS/SET_NEGOTIABLE';
export const SET_NEGOTIABLE_OPTIONS = 'MINHASDIVIDAS/SET_NEGOTIABLE_OPTIONS';
export const SET_RESUME = 'MINHASDIVIDAS/SET_RESUME';
export const SET_PARCELAMNENT_SELECTED = 'MINHASDIVIDAS/SET_PARCELAMNENT_SELECTED';